// Right after signup, the default tenant answers a 5xx until its demo seeding is done (503 tenant_demo_seeding,
// or a 500 while the test database is re-imported). The seeding waits on a queue shared with pool provisioning,
// so the fetch is retried for about 90 s, polling every 5 s at most, instead of ending on /auth/tenant/error.
export const TENANT_UNAVAILABLE_RETRY_DELAYS_MS = [1000, 2000, 3000, ...Array<number>(17).fill(5000)];

export interface TenantFetchResult {
    response: { status: number } | null;
    data: unknown;
    error: unknown;
}

export const TENANT_DEMO_SEEDING_ERROR = 'tenant_demo_seeding';

export const isTenantTemporarilyUnavailable = (result: TenantFetchResult): boolean => {
    if (result.data) return false;
    if (!result.response) return result.error !== null;
    return result.response.status >= 500;
};

const isTenantDemoSeeding = (result: TenantFetchResult): boolean => Array.isArray(result.error) && (result.error[0] as { detail?: unknown } | undefined)?.detail === TENANT_DEMO_SEEDING_ERROR;

interface TenantWaitOptions {
    delays?: number[];
    onDemoSeeding?: () => void;
}

export const fetchTenantWhileUnavailable = async <Result extends TenantFetchResult>(
    fetch: () => Promise<Result>,
    sleep: (delay: number) => Promise<unknown>,
    { delays = TENANT_UNAVAILABLE_RETRY_DELAYS_MS, onDemoSeeding }: TenantWaitOptions = {}
): Promise<Result> => {
    let result = await fetch();
    let demoSeedingSignaled = false;

    for (const delay of delays) {
        if (!isTenantTemporarilyUnavailable(result)) return result;
        if (!demoSeedingSignaled && isTenantDemoSeeding(result)) {
            demoSeedingSignaled = true;
            onDemoSeeding?.();
        }
        await sleep(delay);
        result = await fetch();
    }

    return result;
};
